import {Component} from "@angular/core";
import {Destroyer} from "../../_helpers/Destroyer";

@Component({
  selector: "ui-main-menu",
  templateUrl: "./main-menu.component.html",
  styleUrls: ["./main-menu.component.scss"],
})
export class MainMenuComponent extends Destroyer {}
